// src/i18n/products.ts —— C-13 卡产品与风控页文案包（经 PageDef.i18n 挂入 table 域字典，TD-849）。06 给出文案的键逐字取 06，其余本计划定稿（W-7 回写）
import type { I18nPack } from '../../../shared/src/dc';

export const I18N_PRODUCTS: I18nPack = {
  zh: {
    // 06 C-13 [改写 key]
    productsNote: '卡产品来源于上游共享卡可申请列表，不支持本地新增或删除；本地可编辑产品名称与场景、对客售价（开卡费、销卡费、交易手续费）、单卡额度上限与库存、开卡成本、3DS 标记与上下架。',
    productFormTip: '卡段、卡组织、地区、币种、能力位、最低首充、有效期、上游成本来自上游，不可修改；此处配置平台对用户的名称、售价（开卡费、销卡费、交易手续费）、单卡额度上限与库存、开卡成本、3DS 标记与上下架。',
    toastSyncProducts: '已从上游同步卡产品：新增 {created} · 更新 {updated} · 下架 {disabled}', // 06 Toast 映射
    // 06 C-13 [新增 key]
    tabHits: '命中记录',
    marginInverted: '毛利倒挂',
    marginInvertedTip: '存在代理开卡返佣高于本产品开卡毛利（开卡费 − 开卡成本），请调整代理费率或售价',
    costOpen: '成本',
    upRemain: '上游可开 {n}（上游计数）', // 0044：所属本系统预算的上游可开余量（开卡闸门）
    budgetNone: '无预算',
    cardOpenOff: '上游不可申请',
    cProdName: '产品名称',
    cProdNameEn: '产品名称 (EN)',
    cScene: '适用场景',
    cSceneEn: '适用场景 (EN)',
    cCostOpen: '开卡成本',
    cCostClose: '销卡成本',
    cRefundFeeRate: '退款费率',
    cAuthCancelFeeRate: '授权撤销费率',
    cAuthCancelFeeFixed: '授权撤销固定费',
    cAuthCancelFeeMin: '授权撤销收费门槛',
    cAuthCancelFee: '授权撤销费',
    authCancelEvery: '每笔',
    c3ds: '支持 3DS',
    capsLabel: '上游能力位',
    upInfo: '上游信息',
    upCost: '上游成本',
    limitTip: '单卡最大对客可用额度：增加额度时 可用额度 + 本笔 不得超过（1209）',
    stockTip: '运营可售上限，不随开卡递减；实际可开 = min(库存, 上游可开 {n})',
    sceneTip: '广告投放 / AI 订阅 / 跨境电商', // 06 C-13 scene placeholder
    // 以下本计划定稿
    errLimitMin: '单卡额度上限不能低于最低首充 {min}',
    errFeeRate: '费率须在 0～100 之间，最多 4 位小数',
    errAmountFmt: '金额须为非负数，最多 6 位小数',
    errStockInt: '库存须为非负整数',
    errNameLen: '产品名称不能为空且不超过 64 字',
    cCloseFee: '销卡费',
    cTxFee: '交易手续费',
    cCrossFee: '跨境费',
    cDeclineDispute: '拒付费 · 争议费',
    cBudget: '预算',
    cMinAmount: '最低首充',
    cCustomHolder: '自定义持卡人',
    cValidity: '有效期',
    cIntOnly: '整数金额卡头',
    cSyncedAt: '同步时间',
    cHitAction: '动作',
    cContext: '上下文',
    capOpen: '开卡',
    capFreeze: '冻结',
    capClose: '销卡',
    optYes: '是',
    optNo: '否',
  },
  en: {
    productsNote:
      'Card products are synced from the upstream shared-card catalog and cannot be added or deleted locally; locally you can edit names, scenes, customer pricing (open/close fees, transaction fees), per-card limit, stock, card-opening cost, 3DS flag and availability.',
    productFormTip: // 本计划定稿（06 只给 zh）
      'BIN, brand, region, currency, capabilities, minimum first top-up, validity and upstream cost come from upstream and cannot be changed; configure names, pricing (open/close fees, transaction fees), per-card limit, stock, card-opening cost, 3DS flag and availability here.',
    toastSyncProducts: 'Synced upstream card products: {created} new · {updated} updated · {disabled} unavailable',
    tabHits: 'Hits',
    marginInverted: 'Negative margin',
    marginInvertedTip: "An agent's card-opening commission exceeds this product's margin (open fee − card-opening cost). Adjust agent rates or pricing.",
    // 以下本计划定稿
    costOpen: 'Cost',
    upRemain: 'Upstream allows {n} (upstream count)',
    budgetNone: 'No budget',
    cardOpenOff: 'Not available upstream',
    cProdName: 'Product name',
    cProdNameEn: 'Product name (EN)',
    cScene: 'Use case',
    cSceneEn: 'Use case (EN)',
    cCostOpen: 'Card-opening cost',
    cCostClose: 'Card-closing cost',
    cRefundFeeRate: 'Refund fee rate',
    cAuthCancelFeeRate: 'Auth reversal fee rate',
    cAuthCancelFeeFixed: 'Auth reversal fixed fee',
    cAuthCancelFeeMin: 'Auth reversal fee threshold',
    cAuthCancelFee: 'Auth reversal fee',
    authCancelEvery: 'every txn',
    c3ds: '3DS supported',
    capsLabel: 'Upstream capabilities',
    upInfo: 'Upstream info',
    upCost: 'Upstream cost',
    limitTip: 'Max customer-available amount per card: available + this top-up must not exceed it (1209)',
    stockTip: 'Sellable cap, not decremented by issuance; issuable = min(stock, budget allows {n})',
    sceneTip: 'Ads / AI subscriptions / cross-border e-commerce',
    errLimitMin: 'Per-card limit cannot be below the minimum first top-up {min}',
    errFeeRate: 'Rates must be 0–100 with at most 4 decimals',
    errAmountFmt: 'Amounts must be non-negative with at most 6 decimals',
    errStockInt: 'Stock must be a non-negative integer',
    errNameLen: 'Product name is required (max 64 chars)',
    cCloseFee: 'Close fee',
    cTxFee: 'Transaction fee',
    cCrossFee: 'Cross-border fee',
    cDeclineDispute: 'Decline · dispute fee',
    cBudget: 'Budget',
    cMinAmount: 'Min first top-up',
    cCustomHolder: 'Custom cardholder',
    cValidity: 'Validity',
    cIntOnly: 'Integer amounts only',
    cSyncedAt: 'Synced at',
    cHitAction: 'Action',
    cContext: 'Context',
    capOpen: 'Open',
    capFreeze: 'Freeze',
    capClose: 'Close',
    optYes: 'Yes',
    optNo: 'No',
  },
};

export const REWRITES_PRODUCTS: readonly string[] = ['productsNote', 'productFormTip', 'toastSyncProducts'];
